import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import {
	ARCHIVE_TABLE_COLUMN_KEYS,
	ARCHIVE_TABLE_COLUMN_WIDTHS,
} from '../../../common/ui/constants.tsx';
import messages from './messages.tsx';
import { SelectCell } from './select-cell/main.tsx';

const useTableHeadCells = (unarchiveIssuePermission?: boolean) => {
	const { formatMessage } = useIntl();

	const checkboxHeader =
		(unarchiveIssuePermission && [
			{
				key: ARCHIVE_TABLE_COLUMN_KEYS.SELECT,
				content: <SelectCell />,
				width: ARCHIVE_TABLE_COLUMN_WIDTHS.SELECT,
			},
		]) ||
		[];

	const headCells = {
		cells: [
			...checkboxHeader,
			{
				key: ARCHIVE_TABLE_COLUMN_KEYS.TYPE,
				content: formatMessage(messages.issueTypeColumnHeaderText),
				width: ARCHIVE_TABLE_COLUMN_WIDTHS.TYPE,
			},
			{
				key: ARCHIVE_TABLE_COLUMN_KEYS.KEY,
				content: formatMessage(messages.issueKeyColumnHeaderText),
				width: ARCHIVE_TABLE_COLUMN_WIDTHS.KEY,
			},
			{
				key: ARCHIVE_TABLE_COLUMN_KEYS.SUMMARY,
				content: formatMessage(messages.summaryColumnHeaderText),
				width: ARCHIVE_TABLE_COLUMN_WIDTHS.SUMMARY,
			},
			{
				key: ARCHIVE_TABLE_COLUMN_KEYS.REPORTER,
				content: formatMessage(messages.reporterColumnHeaderText),
				width: ARCHIVE_TABLE_COLUMN_WIDTHS.REPORTER,
			},
			{
				key: ARCHIVE_TABLE_COLUMN_KEYS.ARCHIVED_DATE,
				content: formatMessage(messages.archivedDateColumnHeaderText),
				width: ARCHIVE_TABLE_COLUMN_WIDTHS.ARCHIVED_DATE,
			},
			{
				key: ARCHIVE_TABLE_COLUMN_KEYS.ARCHIVED_BY,
				content: formatMessage(messages.archivedByColumnHeaderText),
				width: ARCHIVE_TABLE_COLUMN_WIDTHS.ARCHIVED_BY,
			},
		],
	};

	return headCells;
};

export default useTableHeadCells;
